import axios from 'axios';
import {handleResponse, handleError, useInterceptor} from './apiUtils';
import {USER_API_URL, GOOGLE_AUTH_URL, FACEBOOK_AUTH_URL, BASE_URL, API_URL} from '../constants';

useInterceptor(axios);

export function signIn(details) {
	return axios({
		method: 'post',
		url: `${API_URL}/login`,
		data: details
	});
}

/** DELETE /api/logout — backend clears auth cookie; must send cookies (withCredentials) so the cookie is cleared. */
export async function signOut() {
	return axios({
		method: 'delete',
		url: `${API_URL}/logout`,
		withCredentials: true  // required so browser sends cookie; backend clears it so refresh doesn’t re-log in
	});
}

export const createUser = (details) => {
	return axios({
		method: 'post',
		url: `${API_URL}/sign_up`,
		data: details
	});
};

export const requestSignupOtp = (email) => {
	return axios({
		method: 'post',
		url: `${API_URL}/sign_up/request_otp`,
		data: { user: { email } }
	});
};

export const verifyOtpAndCreateUser = (details) => {
	return axios({
		method: 'post',
		url: `${API_URL}/sign_up/verify_and_create`,
		data: { user: details }
	});
};

export const authorizeUser = () => {
	return axios({
		method: 'get',
		url: GOOGLE_AUTH_URL
	});
};
